/**
 * Theme toggle component behavior
 */

document.addEventListener('theme:ready', (e) => {
  const { preference } = e.detail;
  updateToggleState(preference);
});

document.addEventListener('theme:change', (e) => {
  const { preference } = e.detail;
  updateToggleState(preference);
});

// Handle toggle clicks
document.addEventListener('click', (e) => {
  const option = e.target.closest('[data-theme-option]');
  if (!option) return;
  
  const theme = option.dataset.themeOption;
  if (window.themeManager) {
    window.themeManager.setPreference(theme);
  }
});

// Handle keyboard navigation
document.addEventListener('keydown', (e) => {
  const toggle = e.target.closest('.theme-toggle');
  if (!toggle) return;
  
  const options = Array.from(toggle.querySelectorAll('[data-theme-option]'));
  const currentIndex = options.findIndex(opt => opt.getAttribute('aria-checked') === 'true');
  
  let newIndex = currentIndex;
  
  if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
    e.preventDefault();
    newIndex = (currentIndex + 1) % options.length;
  } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
    e.preventDefault();
    newIndex = (currentIndex - 1 + options.length) % options.length;
  } else if (e.key === 'Home') {
    e.preventDefault();
    newIndex = 0;
  } else if (e.key === 'End') {
    e.preventDefault();
    newIndex = options.length - 1;
  } else {
    return;
  }
  
  const newOption = options[newIndex];
  if (newOption && window.themeManager) {
    window.themeManager.setPreference(newOption.dataset.themeOption);
    newOption.focus();
  }
});

function updateToggleState(preference) {
  const options = document.querySelectorAll('[data-theme-option]');
  options.forEach(option => {
    const isActive = option.dataset.themeOption === preference;
    option.setAttribute('aria-checked', isActive ? 'true' : 'false');
    option.setAttribute('tabindex', isActive ? '0' : '-1');
    
    // Apply active styling
    if (isActive) {
      option.style.background = 'rgb(var(--color-accent-rgb))';
      option.style.color = 'white';
    } else {
      option.style.background = 'transparent';
      option.style.color = 'rgb(var(--color-text-muted-rgb))';
    }
  });
}
